import React, { Component } from "react";

//history
import history from "../_Utils/History";

//Assets
import backBtn from "../../Assets/backBtn.svg";
import LoginLogo from "../../Assets/LoginLogo.svg";
import LoginEye from "../../Assets/LoginEye.svg";
import LoginEyeDash from "../../Assets/LoginEyeDash.svg";
import forgetPass from "../../Assets/forgetPass.gif";
import setPic from "../../Assets/setPic.svg";
import DoubleArrowIcon from "../../Assets/chevrons-right.svg";
import SearchIcon from "../../Assets/search.svg";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 1,
      isPassword: false,
      isPassword2: false,
      isForget: 1,

      signupTab: 1,
      pic: null,
    };
  }

  componentWillUnmount() {
    window.location.reload();
  }

  goToHome = () => {
    if (this.state.tab !== 1) {
      if (this.state.signupTab !== 1) {
        this.setState({ signupTab: this.state.signupTab - 1 });
      } else {
        this.setState({ tab: 1 });
      }
    } else {
      history.push("/");
    }
  };

  changeTab = (tab) => {
    this.setState({ tab: tab });
  };

  isForgetChange = (isForgetTab, tab) => {
    if (tab !== null) {
      this.setState({ tab: tab, isForget: isForgetTab });
    } else {
      this.setState({ isForget: isForgetTab });
    }
  };

  renderLoginPage() {
    return (
      <div className="Login_Page">
        <div className="Login_Data">
          <div>Simple Secure & Reliable</div>
          <div>
            We help people by tracking their glucose and suggesting them for a
            better diet.
          </div>
        </div>
        <div className="Login_From">
          <div className="Login_FromCard">
            <div className="Login_Logo">
              <img src={LoginLogo} alt="" />
            </div>
            <div className="Login_Input">
              <input
                type="email"
                placeholder="Enter Your Mail"
                onKeyPress={(event) =>
                  event.key === " " ? event.preventDefault() : true
                }
              />
            </div>
            <div className="Login_Input">
              <input
                type={this.state.isPassword ? "text" : "password"}
                placeholder="Enter Your Password"
                onKeyPress={(event) =>
                  event.key === " " ? event.preventDefault() : true
                }
              />
              <div
                className="Login_InputPassword"
                onClick={() => {
                  this.setState({ isPassword: !this.state.isPassword });
                }}
              >
                <img
                  src={this.state.isPassword ? LoginEye : LoginEyeDash}
                  alt=""
                />
              </div>
            </div>
            <div
              className="Login_ForgotPassword"
              onClick={() => {
                this.changeTab(3);
              }}
            >
              Forgot Password?
            </div>
            <div
              className="Login_Btn"
              onClick={() => {
                this.goToHome();
              }}
            >
              Login
            </div>
            <div className="Login_Line"></div>
            <div className="Login_SignUp">
              New User ?
              <span
                onClick={() => {
                  this.changeTab(2);
                }}
              >
                &nbsp;Sign Up
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  singUpChange = (signupTab) => {
    if (signupTab <= 3) {
      this.setState({ signupTab: signupTab });
    }
  };

  setImg = (event) => {
    var image = document.getElementById("output");

    image.src = window.URL.createObjectURL(event.target.files[0]);
    // this.setState({ pic: window.URL.createObjectURL(event.target.files[0]) });
  };

  renderSignup() {
    return (
      <div className="Login_Signup">
        <>
          {this.state.signupTab === 1 ? (
            <div className="Login_SignupCard">
              <div className="Login_SignupCardTitle">
                <div>Set Personal Information</div>
                <div></div>
              </div>
              <div className="Login_SignupCardInput">
                <input type="text" placeholder="Enter Your Name" />
              </div>
              <div className="Login_SignupCardInput">
                <input
                  type="text"
                  onKeyPress={(event) =>
                    event.key === " " ? event.preventDefault() : true
                  }
                  placeholder="Enter Your Email"
                />
              </div>
              <div className="Login_SignupCardInput">
                <input
                  type={this.state.isPassword ? "text" : "password"}
                  onKeyPress={(event) =>
                    event.key !== " " ? true : event.preventDefault()
                  }
                  placeholder="Enter Your Password"
                />
                <div
                  className="Login_SignupCardInputPassword"
                  onClick={() => {
                    this.setState({ isPassword: !this.state.isPassword });
                  }}
                >
                  <img
                    src={this.state.isPassword ? LoginEye : LoginEyeDash}
                    alt=""
                  />
                </div>
              </div>
              <div className="Login_SignupCardInput">
                <input
                  type={this.state.isPassword ? "text" : "password"}
                  onKeyPress={(event) =>
                    event.key !== " " ? true : event.preventDefault()
                  }
                  placeholder="Confirm Your Password"
                />
                <div
                  className="Login_SignupCardInputPassword"
                  onClick={() => {
                    this.setState({ isPassword: !this.state.isPassword });
                  }}
                >
                  <img
                    src={this.state.isPassword ? LoginEye : LoginEyeDash}
                    alt=""
                  />
                </div>
              </div>
              <div
                className="Login_SignupCardTitle"
                style={{ marginTop: "3%" }}
              >
                <div>Set Medical Parameters</div>
                <div></div>
              </div>
              <div className="Login_SignUpCardData">
                <div className="Login_SignUpData">
                  <div className="Login_SignUpDataTitle">Set Height</div>
                  <div className="Login_SignUpDataVal">
                    10 <span>&nbsp;cm</span>
                  </div>
                  <div className="Login_SignUpDataBtn">
                    <div>-</div>
                    <div>+</div>
                  </div>
                </div>

                <div className="Login_SignUpData">
                  <div className="Login_SignUpDataTitle">Set Height</div>
                  <div className="Login_SignUpDataVal">
                    10 <span>&nbsp;kg</span>
                  </div>
                  <div className="Login_SignUpDataBtn">
                    <div>-</div>
                    <div>+</div>
                  </div>
                </div>

                <div className="Login_SignUpData">
                  <div className="Login_SignUpDataTitle">Set Height</div>
                  <div className="Login_SignUpDataVal">
                    AB <span>&nbsp;+</span>
                  </div>
                  <div className="Login_SignUpDataBtn">
                    <div>-</div>
                    <div>+</div>
                  </div>
                </div>
              </div>
            </div>
          ) : this.state.signupTab === 2 ? (
            <div className="Login_SignupCard">
              <div className="Login_SignupCardTitle">
                <div>Select Your Insulin</div>
                <div></div>
              </div>
              <div
                className="Login_SignupCardSetInsulin"
                onClick={() => {
                  this.setState({ signupTab: 4 });
                }}
              >
                <div>Select Insulin Names That You Intake</div>
                <img src={DoubleArrowIcon} alt="" />
              </div>
              <div
                className="Login_SignupCardTitle"
                style={{ marginTop: "3%" }}
              >
                <div>Set Your Schedule</div>
                <div></div>
              </div>
              <div className="Login_SignupCardSetSchedule">
                <div className="Login_SignupCardSetScheduleCard">
                  <div>Set Breakfast Timing</div>

                  <input
                    type="time"
                    id="BreakfastTiming"
                    name="BreakfastTiming"
                  />
                </div>

                <div className="Login_SignupCardSetScheduleCard">
                  <div>Set Breakfast Timing</div>

                  <input
                    type="time"
                    id="BreakfastTiming"
                    name="BreakfastTiming"
                  />
                </div>

                <div className="Login_SignupCardSetScheduleCard">
                  <div>Set Breakfast Timing</div>

                  <input
                    type="time"
                    id="BreakfastTiming"
                    name="BreakfastTiming"
                  />
                </div>
              </div>
            </div>
          ) : this.state.signupTab === 4 ? (
            <div className="Login_SignupCard">
              <div className="Login_SignupCardTitle">
                <div>Select Your Insulin</div>
                <div></div>
              </div>
              <div className="Login_SignupCardSetInsulin">
                <input type="text" placeholder="Enter Insulin Name" />
                <img src={SearchIcon} alt="" />
              </div>

              <div
                className="Login_SignupCardTitle"
                style={{ marginTop: "3%" }}
              >
                <div>Selected List</div>
                <div style={{ width: "70%" }}></div>
              </div>
              <div className="Login_SignupCardSetInsulinList">
                {[...Array(13)].map((data, index) => {
                  return (
                    <div key={index} className="Login_SignupCardSetInsulinCard">
                      <div>Human Actrapid</div>
                      <div>-</div>
                    </div>
                  );
                })}
              </div>

              <div
                className="Login_SignupCardTitle"
                style={{ marginTop: "3%" }}
              >
                <div>Insulin List</div>
                <div style={{ width: "70%" }}></div>
              </div>
              <div className="Login_SignupCardSetInsulinList">
                {[...Array(13)].map((data, index) => {
                  return (
                    <div key={index} className="Login_SignupCardSetInsulinCard">
                      <div>Human Actrapid</div>
                      <div>+</div>
                    </div>
                  );
                })}
              </div>

              <div
                className="Login_SignupCardSetInsulinSubmit"
                onClick={() => {
                  this.setState({ signupTab: 2 });
                }}
              >
                Submit
              </div>
            </div>
          ) : (
            <div className="Login_SignupCardLast">
              <div>
                <label htmlFor="pic">
                  <div>
                    <img id="output" src={setPic} alt="" />
                  </div>
                </label>
                <input type="file" name="pic" id="pic" onChange={this.setImg} />
              </div>
              <div className="Login_SignupCardLastTitle">
                Click to set image for your profile
              </div>
              <div
                className="Login_Btn"
                onClick={() => {
                  this.setState({ tab: 1 });
                }}
              >
                Finish SignUp
              </div>
            </div>
          )}
        </>
        <div className="Login_SignupDots">
          <div
            style={{
              backgroundColor:
                this.state.signupTab === 1 ? "rgba(255, 255, 255, 1)" : "",
            }}
            onClick={() => {
              this.singUpChange(1);
            }}
          ></div>
          <div
            style={{
              backgroundColor:
                this.state.signupTab === 2 ? "rgba(255, 255, 255, 1)" : "",
            }}
            onClick={() => {
              this.singUpChange(2);
            }}
          ></div>
          <div
            style={{
              backgroundColor:
                this.state.signupTab === 3 ? "rgba(255, 255, 255, 1)" : "",
            }}
            onClick={() => {
              this.singUpChange(3);
            }}
          ></div>
        </div>

        <div
          className="Login_backBtn"
          onClick={() => {
            this.singUpChange(this.state.signupTab + 1);
          }}
        >
          <img src={backBtn} alt="Setting" />
        </div>
      </div>
    );
  }

  renderForgetPass() {
    return (
      <div className="Login_ForgeHolder">
        <div
          className="Login_ForgetCard"
          style={{ height: this.state.isForget === 3 ? "82%" : "" }}
        >
          <div className="Login_ForgetCardIcon">
            <img src={forgetPass} alt="" />
          </div>
          <div className="Login_ForgetTitle">
            {this.state.isForget === 1
              ? "Forgot Password?"
              : this.state.isForget === 2
              ? "Verify Email Address"
              : this.state.isForget === 3
              ? "New Password"
              : ""}
          </div>
          <div className="Login_ForgetInfo">
            Please write your email to receive a confirmation code to set a new
            password
          </div>
          {this.state.isForget === 1 ? (
            <div className="Login_Input">
              <input
                type="email"
                placeholder="Enter Your Mail"
                onKeyPress={(event) =>
                  event.key === " " ? event.preventDefault() : true
                }
              />
            </div>
          ) : this.state.isForget === 2 ? (
            <div className="Login_ForgetOtp">
              <input
                type="text"
                placeholder="0"
                onKeyPress={(event) =>
                  event.key !== " " && event.key >= 0 && event.key <= 9
                    ? true
                    : event.preventDefault()
                }
                maxLength="1"
                minLength="1"
              />
              <input
                type="text"
                placeholder="0"
                onKeyPress={(event) =>
                  event.key !== " " && event.key >= 0 && event.key <= 9
                    ? true
                    : event.preventDefault()
                }
                maxLength="1"
                minLength="1"
              />
              <input
                type="text"
                placeholder="0"
                onKeyPress={(event) =>
                  event.key !== " " && event.key >= 0 && event.key <= 9
                    ? true
                    : event.preventDefault()
                }
                maxLength="1"
                minLength="1"
              />
              <input
                type="text"
                placeholder="0"
                onKeyPress={(event) =>
                  event.key !== " " && event.key >= 0 && event.key <= 9
                    ? true
                    : event.preventDefault()
                }
                maxLength="1"
                minLength="1"
              />
            </div>
          ) : this.state.isForget === 3 ? (
            <>
              <div className="Login_ForgetInput">
                <input
                  type={this.state.isPassword ? "text" : "password"}
                  placeholder="Enter Your Password"
                  onKeyPress={(event) =>
                    event.key === " " ? event.preventDefault() : true
                  }
                />
                <div
                  className="Login_ForgetInputPassword"
                  onClick={() => {
                    this.setState({ isPassword: !this.state.isPassword });
                  }}
                >
                  <img
                    src={this.state.isPassword ? LoginEye : LoginEyeDash}
                    alt=""
                  />
                </div>
              </div>

              <div className="Login_ForgetInput">
                <input
                  type={this.state.isPassword ? "text" : "password"}
                  placeholder="Enter Your Password"
                  onKeyPress={(event) =>
                    event.key === " " ? event.preventDefault() : true
                  }
                />
                <div
                  className="Login_ForgetInputPassword"
                  onClick={() => {
                    this.setState({ isPassword: !this.state.isPassword });
                  }}
                >
                  <img
                    src={this.state.isPassword ? LoginEye : LoginEyeDash}
                    alt=""
                  />
                </div>
              </div>
            </>
          ) : null}
          <div
            className="Login_Btn"
            onClick={() => {
              if (this.state.isForget === 1) {
                this.isForgetChange(2, null);
              } else if (this.state.isForget === 2) {
                this.isForgetChange(3, null);
              } else if (this.state.isForget === 3) {
                this.isForgetChange(1, 1);
              }
            }}
          >
            Confirm Mail
          </div>
        </div>
        {this.state.isForget === 2 && (
          <div className="Login_resend">00:28 Resend Confirmation Code</div>
        )}
      </div>
    );
  }

  renderTab() {
    if (this.state.tab === 1) {
      return <>{this.renderLoginPage()}</>;
    } else if (this.state.tab === 2) {
      return <>{this.renderSignup()}</>;
    } else if (this.state.tab === 3) {
      return <>{this.renderForgetPass()}</>;
    }
  }

  render() {
    return (
      <div className="Login">
        <div className="backBtn" onClick={this.goToHome}>
          <img src={backBtn} alt="Setting" />
        </div>

        {this.renderTab()}
      </div>
    );
  }
}

export default Login;
